import { React, useState, useEffect, useCallback } from 'react';
import { Form, Button, Card } from 'react-bootstrap';

import axios from 'axios';
import { BrowserRouter as Router, Route, Switch, Routes, Link } from "react-router-dom";
import connect_with_yt from './../../connect_with_yt.png';
import connect_with_insta from './../../assets/facebook-icon-reverse.svg';
import connect_with_tiktok from './../../connect_with_tiktok.png';
import info_icon from './../../assets/info_icon.svg';
import PlaceholderImage from './../../assets/placeholder_image.jpg';
import Accordion from 'react-bootstrap/Accordion';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoadingOverlay from 'react-loading-overlay-ts';
import Modal from "react-bootstrap/Modal";
import InstagramTutorial from './../ShortsMaker/AuthParts/InstagramTutorial';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import VideoPlayer from '../VideoPlayer';
import Header from '../Header';
import { useLocation, useNavigate } from 'react-router-dom';
import { instagram_icon, tiktok_icon, youtube_icon } from './../../assets/social_icons';
import './AuthSection.css';
import XUploadPanel from './AuthParts/XUploadPanel';

// X posting panel. Shown by default; hide it with REACT_APP_ENABLE_X=false.
const X_ENABLED = process.env.REACT_APP_ENABLE_X !== 'false';

const AuthSection = ({ video_url123 }) => {
    const location = useLocation();
    const navigate = useNavigate();

    // Return to the page the user came from (their shorts listing). Falls back to
    // Home if there's no in-app history (e.g. /upload opened directly).
    const handleBack = () => {
        if (window.history.length > 1) {
            navigate(-1);
        } else {
            navigate('/');
        }
    };
    // console.log("video_url from iframe", video_url123);
    var video_url = '';
    if (video_url123 !== null) {
        video_url = video_url123;
    } else {
        const ShortsMakerField = location.state?.ShortsMakerField;
        // console.log("ShortsMakerField data on upload page", ShortsMakerField);
        video_url = ShortsMakerField?.video_url;
    }
    // console.log("Video url on upload page", video_url);
    // const video_url = "https://storage.googleapis.com/klap-renders/edbdeadc-0ce7-4503-9ced-8250d3ad72f1-d1bb538c-8a9e-4ddc-b8ef-d36c9d9ee801.mp4";
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [isInstaLoggedIn, setIsInstaLoggedIn] = useState(false);
    const [isTiktokLoggedIn, setIsTiktokLoggedIn] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    // const [videoFile, setVideoFile] = useState(null);

    // Add Font Awesome
    useEffect(() => {
        // Create a link element for Font Awesome
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css';
        document.head.appendChild(link);
        
        // Clean up function to remove the link when component unmounts
        return () => {
            document.head.removeChild(link);
        };
    }, []);

    const [isUploading, setIsUploading] = useState(false);
    const [uploadMessage, setUploadMessage] = useState('');
    const [alertShow, setAlertShow] = useState(false);
    const [userInfo, setUserInfo] = useState({
        google: {},
        instagram: {},
        tiktok: {}
    });
    const [channelInfo, setChannelInfo] = useState({
        google: {},
        instagram: {},
        tiktok: {}
    });

    const [videoTitle, setVideoTitle] = useState('');
    const [videoDescription, setVideoDescription] = useState('');
    const [videoTags, setVideoTags] = useState([]);
    const [IsTermsAgreed, setTermsAgreed] = useState(false);

    const [accessSpecifier, setAccessSpecifier] = useState('private');

    // tiktok form metas
    const [tiktokvideoTitle, settiktokVideoTitle] = useState('');
    const [tiktokvideoTags, settiktokVideoTags] = useState([]);
    const [tiktokaccessSpecifier, settiktokAccessSpecifier] = useState('');



    const [tiktokDisclose, setTiktokDisclose] = useState(false);
    const [tiktokYourBrand, setTiktokYourBrand] = useState(false);
    const [tiktokBrandedContent, setTiktokBrandedContent] = useState(false);
    const [publishId, setPublishId] = useState('');
    // TikTok publish status UX (loader -> success/error overlay)
    const [uploadStatus, setUploadStatus] = useState(null);
    const [tiktokPostUrl, setTiktokPostUrl] = useState('');
    const [uploadError, setUploadError] = useState('');
    const [statusOverlayDismissed, setStatusOverlayDismissed] = useState(false);


    const [comment, setComment] = useState(false);
    const [duet, setDuet] = useState(false);
    const [stitch, setStitch] = useState(false);

    const [show, setShow] = useState(false);
    const [thankyoushow, setThankyoushow] = useState(false);
    const handleClose = () => setShow(false);
    const handleThankYouClose = () => setThankyoushow(false);
    const handlesetShow = () => setShow(true);
    const apiUrl = process.env.REACT_APP_API_URL;
    const App_Url = process.env.REACT_APP_URL + "/calllback?status=1";

    const MAX_VIDEO_DURATION_SEC = 300;
    const [videoUrl, setVideoUrl] = useState(''); // State to store video URL

    const [creatorInfo, setCreatorInfo] = useState(null);
    const [canPost, setCanPost] = useState(true);
    const [whyCant, setwhyCant] = useState('');
    const [videoPreview, setVideoPreview] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [selectedPageId, setSelectedPageId] = useState(0);
    const [publishButton, setPublishButton] = useState(false);
    const [instagramBusinessAccountId, setInstagramBusinessAccountId] = useState(0);
    const [noInstaAccountText, setNoInstaAccountText] = useState('');
    const [uploadedMediaUrl, setUploadedMediaUrl] = useState('');
    // Best-effort metadata for the video card's info bar (remote clip URL, not an
    // uploaded file — so filename/format come from the URL and resolution from the media).
    const [videoMeta, setVideoMeta] = useState({ filename: '', format: '', resolution: '' });
    // Recent posts on the connected TikTok account (uses the video.list scope / Display API)
    const [recentVideos, setRecentVideos] = useState([]);
    // The recent-posts gallery is collapsed by default; the user toggles it open.
    const [showRecentVideos, setShowRecentVideos] = useState(false);

    const handleInstagramAccountChange = (event) => {
        setInstagramBusinessAccountId(event.target.value);
    };

    useEffect(() => {
        console.log("creatorInfo ", creatorInfo);
    }, [creatorInfo]);


    useEffect(() => {
        if (!isTiktokLoggedIn) {
            return;
        }
        // Fetch creator information from the API
        axios
            .get(apiUrl + '/creator_info', {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('tiktokToken')}`,
                },
            })
            .then((response) => {
                console.log("response --------------------------------", response, response?.data?.error?.code);
                if (response?.data?.error?.code == 'ok') {
                    setCanPost(true);
                    setwhyCant('');
                } else {
                    setCanPost(false);

                    if (response?.data?.error?.code == 'spam_risk_too_many_posts') {
                        setwhyCant('The daily post capability reached.');
                    } else if (response?.data?.error?.code == 'spam_risk_user_banned_from_posting') {
                        setwhyCant('You are banned from making new posts.');
                    } else if (response?.data?.error?.code == 'reached_active_user_cap') {
                        setwhyCant('TikTok has temporarily reached its daily posting limit for our app. Please try again later.');
                    } else if (response?.data?.error?.code == 'unaudited_client_can_only_post_to_private_accounts') {
                        setwhyCant('Unaudited clients can only post to a private account.');
                    }


                    // setwhyCant(response?.error?.code);
                    console.log("CanPost", canPost);
                }
                setCreatorInfo(response.data);
                // setCanPost(response.data.can_post);

            })
            .catch((error) => {
                console.error('Error fetching creator info:', error);
            });
    }, [isTiktokLoggedIn]);


    // Derive the video card's metadata: filename + format from the URL (instant),
    // resolution by probing the media's intrinsic height.
    useEffect(() => {
        if (!video_url) return undefined;
        let filename = '';
        let format = '';
        try {
            const pathname = new URL(video_url, window.location.origin).pathname;
            const base = decodeURIComponent((pathname.split('/').pop() || '').split('?')[0]);
            if (base) {
                filename = base;
                const dot = base.lastIndexOf('.');
                if (dot > -1) format = base.slice(dot + 1).toUpperCase();
            }
        } catch (e) { /* malformed URL — leave blank */ }
        setVideoMeta({ filename, format, resolution: '' });

        const probe = document.createElement('video');
        probe.preload = 'metadata';
        const onMeta = () => {
            if (probe.videoHeight) {
                setVideoMeta((m) => ({ ...m, resolution: `${probe.videoHeight}P` }));
            }
        };
        probe.addEventListener('loadedmetadata', onMeta);
        probe.src = video_url;

        return () => {
            probe.removeEventListener('loadedmetadata', onMeta);
            probe.removeAttribute('src');
        };
    }, [video_url]);


    // Load the creator's recent TikTok posts (video.list / Display API) so we can
    // show a gallery on the upload screen — gives the video.list scope a real,
    // user-facing purpose.
    const fetchRecentVideos = useCallback(() => {
        if (!isTiktokLoggedIn) return;
        axios
            .get(apiUrl + '/api/tiktok/videos', {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('tiktokToken')}`,
                },
            })
            .then((response) => {
                setRecentVideos(response?.data?.data?.videos || []);
            })
            .catch((error) => {
                console.error('Error fetching TikTok video list:', error);
            });
    }, [isTiktokLoggedIn, apiUrl]);

    // Initial load when the account connects.
    useEffect(() => {
        fetchRecentVideos();
    }, [fetchRecentVideos]);

    // After a successful upload, refetch the gallery — with delayed retries
    // because TikTok's video.list lags behind a just-published post.
    useEffect(() => {
        if (uploadStatus !== 'PUBLISH_COMPLETE') return undefined;
        const timers = [0, 8000, 25000].map((delay) => setTimeout(fetchRecentVideos, delay));
        return () => timers.forEach(clearTimeout);
    }, [uploadStatus, fetchRecentVideos]);


    useEffect(() => {
        let cancelled = false;
        const pollVideoStatus = async () => {
            try {
                const response = await axios.post(`${apiUrl}/upload/status/fetch`, {
                    publish_id: publishId, // Pass the publish_id in the request body
                }, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('tiktokToken')}`,
                    },
                });
                if (cancelled) return;
                const status = response.data.status;
                setUploadStatus(status);
                if (status === 'PUBLISH_COMPLETE') {
                    // Build the public TikTok link when the post id + creator username are available
                    const postId = response.data.postId;
                    const username =
                        creatorInfo?.data?.creator_username ||
                        creatorInfo?.creator_username || '';
                    if (postId && username) {
                        setTiktokPostUrl(`https://www.tiktok.com/@${username}/video/${postId}`);
                    } else if (username) {
                        setTiktokPostUrl(`https://www.tiktok.com/@${username}`);
                    }
                    toast.success('Video uploaded successfully!');
                    setUploadMessage('The video has been successfully uploaded to TikTok.');
                    setAlertShow(true);
                    setIsSubmitting(false);
                } else if (status === 'FAILED' || status === 'PUBLISH_FAILED') {
                    toast.error('Video upload failed.');
                    setUploadError('The video upload to TikTok has failed.');
                    setIsSubmitting(false);
                } else {
                    // Still processing (PROCESSING_DOWNLOAD / PROCESSING_UPLOAD / SEND_TO_USER_INBOX) — keep polling
                    setTimeout(pollVideoStatus, 5000);
                }
            } catch (error) {
                if (cancelled) return;
                // Backend returns 400 (with an error message) when TikTok reports FAILED
                const apiError = error?.response?.data?.error;
                if (apiError) {
                    setUploadStatus('FAILED');
                    setUploadError(typeof apiError === 'string' ? apiError : 'The video upload to TikTok has failed.');
                    toast.error('Video upload failed.');
                    setIsSubmitting(false);
                } else {
                    // transient/network error — keep polling
                    console.error('Error polling video status:', error);
                    setTimeout(pollVideoStatus, 5000);
                }
            }
        };

        if (publishId) {
            // fresh upload: reset the status overlay
            setUploadStatus('PROCESSING_DOWNLOAD');
            setUploadError('');
            setTiktokPostUrl('');
            setStatusOverlayDismissed(false);
            pollVideoStatus();
        }
        return () => { cancelled = true; };
    }, [publishId]);


    // Returns the reason the Upload button is blocked, or '' when posting is allowed.
    // Disclosure is OPTIONAL per TikTok's UX guidelines — we only block when the
    // disclosure toggle is ON but no brand option has been chosen.
    const getPublishBlockReason = () => {
        if (!canPost) {
            return whyCant || 'You cannot post to this account right now. Please try again later.';
        }
        if (tiktokvideoTitle.trim().length === 0) {
            return 'Please add a title for your video.';
        }
        if (tiktokaccessSpecifier === '') {
            return 'Please choose who can view this video.';
        }
        if (tiktokDisclose && !tiktokYourBrand && !tiktokBrandedContent) {
            return 'You need to indicate if your content promotes yourself, a third party, or both.';
        }
        return '';
    };


    const checkVideoDuration = async (videoUrl, maxDuration) => {
        // Create a video element
        const videoElement = document.createElement('video');

        // Set the source of the video element
        videoElement.src = videoUrl;

        // Ensure that the metadata is loaded
        await new Promise((resolve, reject) => {
            videoElement.addEventListener('loadedmetadata', () => {
                // Once metadata is loaded, resolve the promise
                resolve();
            });

            // Handle errors if the video fails to load
            videoElement.addEventListener('error', (error) => {
                reject(error);
            });
        });

        // Access the duration of the video
        const videoDuration = videoElement.duration;
        // Check if the video duration is within the maximum allowed duration
        return videoDuration <= maxDuration;
    };


    // Define your privacy level options as constants
    const PRIVACY_OPTIONS = {
        SELF_ONLY: 'SELF_ONLY',
        PUBLIC_TO_EVERYONE: 'PUBLIC_TO_EVERYONE',
        MUTUAL_FOLLOW_FRIENDS: 'MUTUAL_FOLLOW_FRIENDS',
        FOLLOWER_OF_CREATOR: 'FOLLOWER_OF_CREATOR',
    };

    // Human-readable labels for the privacy levels TikTok may return in
    // creator_info.privacy_level_options. We render ONLY the options the API
    // returns (TikTok UX requirement), so e.g. unaudited clients see only Private.
    const PRIVACY_LABELS = {
        SELF_ONLY: 'Private (Only me)',
        PUBLIC_TO_EVERYONE: 'Public',
        MUTUAL_FOLLOW_FRIENDS: 'Mutual Followers & Friends',
        FOLLOWER_OF_CREATOR: 'Followers',
    };


    const handleDisconnect = (platform) => {
        // // console.log(`Attempting to disconnect with ${platform}`);
        switch (platform) {
            case 'instagram':
                localStorage.removeItem('instagramToken');
                localStorage.removeItem('instagramAuthToken');
                localStorage.removeItem('platform');
                setIsInstaLoggedIn(false);
                break;
            case 'tiktok':
                localStorage.removeItem('tiktokToken');
                localStorage.removeItem('tiktokAuthToken');
                localStorage.removeItem('platform');
                setIsTiktokLoggedIn(false);
                break;
            case 'google':
                localStorage.removeItem('googleToken');
                setIsLoggedIn(false);
                break;
            default:
                break;
        }
    };

    let popupWindow = null;
    

    const handleLogin = (service) => {
        setShow(false);
        let serviceUrl = '';
        switch (service) {
            case 'google':
                serviceUrl = `/auth/google/url_channel_info?customParam=${encodeURIComponent(App_Url)}`;
                break;
            case 'instagram':
                serviceUrl = `/auth/instagram/url?customParam=${encodeURIComponent(App_Url)}`;
                break;
            case 'tiktok':
                serviceUrl = `/auth/tiktok/url?customParam=${encodeURIComponent(App_Url)}`;
                break;
            default:
                break;
        }

        axios.get(apiUrl + serviceUrl)
            .then(response => {
                const authUrl = response.data.authUrl;
                popupWindow = window.open(
                    authUrl,
                    'targetWindow',
                    `toolbar=no,
                    location=no,
                    status=no,
                    menubar=no,
                    scrollbars=yes,
                    resizable=yes,
                    width=600,
                    height=600`
                );

            })
            .catch(error => {
                console.error(`Failed to retrieve login URL for ${service}:`, error);
            });
    };


    const fetchUserInfo = (platform) => {
        const token = localStorage.getItem(`${platform}Token`);
        // console.log("token", token);
        if (!token) return;

        let url;
        if (platform === 'google') {
            const googleToken = localStorage.getItem('googleToken');
            url = `${apiUrl}/auth/userinfo?access_token=${googleToken}`;
        } else if (platform === 'instagram') {
            const instagramToken = localStorage.getItem('instagramAuthToken');
            console.log("instagramToken", instagramToken);
            url = `${apiUrl}/auth/instagram/userinfo?access_token=${instagramToken}`;
        } else if (platform === 'tiktok') {
            url = `${apiUrl}/auth/tiktok/userinfo?access_token=${token}`;
        }

        axios.get(url)
            .then(response => {
                // console.log("p the", userInfo);
                setUserInfo(prevState => ({
                    ...prevState,
                    [platform]: response.data
                }));
            })
            .catch(error => {
                console.error(`Error fetching ${platform} user info:`, error);
            });
    };


    // create a function to get the channel info
    const getChannelInfo = async (platform) => {
        const token = localStorage.getItem(`${platform}Token`);
        if (!token) return;

        const url = `${apiUrl}/youtube/channel-info?access_token=${token}`;
        axios.get(url)
            .then(response => {
                console.log("channel info", response);
                setChannelInfo(prevState => ({
                    ...prevState,
                    [platform]: response.data
                }));
            })
            .catch(error => {
                console.error(`Error fetching ${platform} channel info:`, error);
            });

    }

    useEffect(() => {
        if (isLoggedIn) {
            fetchUserInfo('google');
            getChannelInfo('google');
        }
    }, [isLoggedIn]);

    useEffect(() => {
        if (isInstaLoggedIn) {
            fetchUserInfo('instagram');
        }
    }, [isInstaLoggedIn]);

    useEffect(() => {
        if (isTiktokLoggedIn) {
            fetchUserInfo('tiktok');
        }
    }, [isTiktokLoggedIn]);


    const checkLoginStatus = () => {
        setIsLoading(true);
        const googleToken = localStorage.getItem('googleToken');
        const instagramToken = localStorage.getItem('instagramAuthToken');
        const tiktokToken = localStorage.getItem('tiktokAuthToken');

        // Check if at least one token is set
        if (googleToken || instagramToken || tiktokToken) {
            axios.get(`${apiUrl}/auth/login/status`, {
                params: {
                    token: googleToken, // Google token
                    insta_token: instagramToken, // Instagram token
                    tiktok_token: tiktokToken // TikTok token
                }
            })
                .then(response => {
                    // console.log("Login response-------", response);
                    if (response?.data?.newGoogleToken) {
                        localStorage.setItem('googleToken', response.data.newGoogleToken);
                    }
                    setIsLoggedIn(response.data.isLoggedIn);
                    setIsInstaLoggedIn(response.data.isInstaLoggedIn);
                    // if (response?.data?.newTiktokToken) {
                    //     localStorage.setItem('tiktokAuthToken', response.data.newTiktokToken);
                    // }
                    setIsTiktokLoggedIn(response.data.isTiktokLoggedIn);
                    setIsLoading(false);
                })
                .catch(error => {
                    console.error('Error checking login status:', error);
                    localStorage.removeItem('googleToken');
                    localStorage.removeItem('instagramAuthToken');
                    localStorage.removeItem('tiktokAuthToken');
                    setIsLoggedIn(false);
                    setIsInstaLoggedIn(false);
                    setIsTiktokLoggedIn(false);
                    setIsLoading(false);
                });
        } else {
            // No tokens are set, so no need to call the API
            setIsLoggedIn(false);
            setIsInstaLoggedIn(false);
            setIsTiktokLoggedIn(false);
            setIsLoading(false);
        }
    };

    useEffect(() => {
        checkLoginStatus();
    }, []);

    useEffect(() => {
        document.body.classList.add('dcs-iframe-only');
        return () => {
            document.body.classList.remove('dcs-iframe-only');
        };
    }, []);

    const validateForm = () => {
        if (videoTitle.length === 0) {
            toast.error("Video Title is required.");
            return false;
        }
        if (videoDescription.length === 0) {
            toast.error("Video Description is required.");
            return false;
        }

        if (!IsTermsAgreed) {
            toast.error("Please agree to abide by YouTube's Terms of Service and Copyright Policies.");
            return false;
        }

        return true;
    };

    const validateTiktokForm = () => {
        if (tiktokvideoTitle.length === 0) {
            toast.error("Video Title is required.");
            return false;
        }
        if (tiktokaccessSpecifier === '') {
            toast.error("Please choose privacy option.");
            return false;
        }

        // Disclosure is optional. Only require a brand selection when the user
        // has explicitly turned the disclosure toggle ON.
        if (tiktokDisclose && !tiktokYourBrand && !tiktokBrandedContent) {
            toast.error("You need to indicate if your content promotes yourself, a third party, or both.");
            return false;
        }

        // Add additional validations as needed
        return true;
    };

    // const handleSubmit = (event) => {
    //     event.preventDefault();

    //     if (!validateForm()) {
    //         return; // Stop the form submission if validation fails
    //     }

    //     setIsUploading(true); // Start upload


    //     const data = {
    //         video_url: video_url,
    //         title: videoTitle,
    //         description: videoDescription,
    //         accessSpecifier: accessSpecifier,
    //         tags: Array.isArray(videoTags) ? videoTags.join(',') : ''
    //     };

    //     axios.post(apiUrl + '/upload', data, {
    //         headers: {
    //             'Content-Type': 'application/json',
    //             Authorization: `Bearer ${localStorage.getItem('googleToken')}`
    //         }
    //     })
    //         .then(response => {
    //             // console.log("response from upload", response);
    //             setIsUploading(false);
    //             const videoId = response.data.videoData.id;  // Make sure the response structure matches
    //             const youtubeVideoUrl = `https://www.youtube.com/watch?v=${videoId}`;
    //             // setYoutubeData({
    //             //     videoId: videoId,
    //             //     videoUrl: youtubeVideoUrl,
    //             //     uploadStatus: true
    //             // });

    //             // setCheckboxState(prevData => ({
    //             //     ...prevData,
    //             //     checkbox1: false
    //             // }));

    //             toast.success('Video uploaded successfully!');

    //         })
    //         .catch(error => {
    //             setIsUploading(false)
    //             // setYoutubeData(prevData => ({
    //             //     ...prevData,
    //             //     uploadStatus: false
    //             // }));
    //             toast.error('Upload failed: ' + error.message);

    //         });
    // };



    const handleSubmit = (event) => {
        event.preventDefault();

        if (!validateForm()) {
            return; // Stop the form submission if validation fails
        }

        setIsUploading(true); // Start upload

        const data = {
            video_url: video_url,
            title: videoTitle,
            description: videoDescription,
            accessSpecifier: accessSpecifier,
            tags: Array.isArray(videoTags) ? videoTags.join(',') : ''
        };

        axios.post(apiUrl + '/upload', data, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${localStorage.getItem('googleToken')}`
            }
        })
            .then(response => {
                // console.log("response from upload", response);
                setIsUploading(false);
                const videoId = response.data.videoData.id;  // Make sure the response structure matches
                const youtubeVideoUrl = `https://www.youtube.com/watch?v=${videoId}`;
                toast.success('Video uploaded successfully!');
            })
            .catch(error => {
                setIsUploading(false)
                const errorMessage = error.response && error.response.data ? error.response.data : error.message;
                toast.error('Upload failed: ' + errorMessage);
            });
    };

    const handleInstaSubmit = (event) => {
        event.preventDefault();
        console.log("setIsUploading", true);
        setIsUploading(true); // Start upload
        setUploadMessage('');
        setAlertShow(false);
        // Create FormData instance
        // const formData = new FormData();
        const data = {
            video_url: video_url,
            title: videoTitle,
            fb_page_id: selectedPageId,
            insta_page_id: instagramBusinessAccountId
        };

        // Request video upload
        axios.post(apiUrl + '/upload/instagram', data, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('instagramToken')}`
            }
        })
            .then(response => {
                setIsUploading(false); // Upload complete
                toast.success('Video uploaded successfully!');
                setUploadMessage('Once the video is generated, we will upload it to Instagram reel with the metadata you submitted');
                setAlertShow(true); // Show
                console.log("Media Upload Response", response);
                setUploadedMediaUrl(response.data.permalink);

                setThankyoushow(true);
            })
            .catch(error => {
                setIsUploading(false); // Upload complete
                setUploadMessage('Upload failed: ' + error.message);
            });
    };


    const handleTiktokSubmit = (event) => {
        event.preventDefault();

        setIsUploading(true); // Start upload
        setUploadMessage('');
        setAlertShow(false);
        // Create FormData instance
        const formData = new FormData();

        // Request video upload
        axios.post(apiUrl + '/upload/tiktok', formData, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('tiktokToken')}`
            }
        })
            .then(response => {
                setIsUploading(false); // Upload complete
                setUploadMessage('Once the video is generated, we will upload it to Tiktok with the metadata you submitted');
                setAlertShow(true); // Show
            })
            .catch(error => {
                setIsUploading(false); // Upload complete
                setUploadMessage('Upload failed: ' + error.message);
            });
    };
    // const handleTiktokFeedsSubmit = async (event) => {
    //     event.preventDefault();

    //     if (!validateTiktokForm()) {
    //       return; // Stop the form submission if validation fails
    //     }

    //     // Check if the video duration exceeds the maximum allowed duration
    //     try {
    //       const isDurationValid = await checkVideoDuration(video_url, creatorInfo.max_video_post_duration_sec);

    //       if (!isDurationValid) {
    //         // Display message to user indicating that video duration exceeds the limit
    //         toast.error(`Video duration exceeds the maximum allowed duration of ${creatorInfo.max_video_post_duration_sec} seconds.`);
    //         return; // Stop current publishing attempt
    //       }

    //       if (!canPost) {
    //         toast.error('Cannot post at the moment. Please try again later.');
    //         return; // Stop current publishing attempt
    //       }

    //       setIsSubmitting(true);
    //       setUploadMessage('');
    //       setAlertShow(false);

    //       const data = {
    //         video_url: video_url,
    //         tiktokvideoTitle: tiktokvideoTitle,
    //         tiktokaccessSpecifier: tiktokaccessSpecifier,
    //         comment: comment,
    //         duet: duet,
    //         stitch: stitch,
    //         tiktokDisclose: tiktokDisclose,
    //         tiktokYourBrand: tiktokYourBrand,
    //         tiktokBrandedContent: tiktokBrandedContent,
    //       };

    //       // Request video upload
    //       axios
    //         .post(apiUrl + '/upload/tiktok_feeds', data, {
    //           headers: {
    //             Authorization: `Bearer ${localStorage.getItem('tiktokToken')}`,
    //           },
    //         })
    //         .then((response) => {
    //           setIsSubmitting(false); // Upload complete
    //           toast.success('Video uploaded successfully!');
    //           setUploadMessage('Once the video is generated, we will upload it to Tiktok with the metadata you submitted');
    //           setAlertShow(true); // Show
    //         })
    //         .catch((error) => {
    //           setIsSubmitting(false); // Upload complete
    //           setUploadMessage('Upload failed: ' + error.message);
    //         });
    //     } catch (error) {
    //       console.error('Error while checking video duration:', error);
    //     }
    //   };




    const handleTiktokFeedsSubmit = async (event) => {
        event.preventDefault();

        if (!validateTiktokForm()) {
            return; // Stop the form submission if validation fails
        }

        // Check if the video duration exceeds the maximum allowed duration
        try {
            const isDurationValid = await checkVideoDuration(video_url, creatorInfo?.data?.max_video_post_duration_sec);

            if (!isDurationValid) {
                // Display message to user indicating that video duration exceeds the limit
                toast.error(`Video duration exceeds the maximum allowed duration of ${creatorInfo?.data?.max_video_post_duration_sec} seconds.`);
                return; // Stop current publishing attempt
            }

            if (!canPost) {
                toast.error(whyCant);
                return; // Stop current publishing attempt
            }


            window.scrollTo(0, 0);

            setIsSubmitting(true);
            setIsUploading(true); // Start upload
            setUploadMessage('');
            setAlertShow(false);

            const data = {
                video_url: video_url,
                tiktokvideoTitle: tiktokvideoTitle,
                tiktokaccessSpecifier: tiktokaccessSpecifier,
                comment: comment,
                duet: duet,
                stitch: stitch,
                tiktokDisclose: tiktokDisclose,
                tiktokYourBrand: tiktokYourBrand,
                tiktokBrandedContent: tiktokBrandedContent,
                // Mandatory fields as per TikTok API update (October 14, 2025)
                brand_content_toggle: tiktokBrandedContent, // Required: Set to true if promoting third-party business
                brand_organic_toggle: tiktokYourBrand // Required: Set to true if promoting creator's own business
            };

            // Request video upload
            axios.post(apiUrl + '/upload/tiktok_feeds', data, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('tiktokToken')}`,
                },
            })
                .then((response) => {
                    // Video upload initiated successfully
                    toast.info('Video upload initiated. Polling for status...');
                    setPublishId(response.data.publish_id); // Store the publish_id
                    setIsUploading(false); // Start upload
                })
                .catch((error) => {
                    setIsSubmitting(false);
                    setIsUploading(false); // Start upload
                    // Surface TikTok's specific error code (the backend now returns it)
                    // instead of a generic "status code 500".
                    const code = error?.response?.data?.error?.code;
                    const messages = {
                        reached_active_user_cap: 'TikTok has temporarily reached its daily posting limit for our app. Please try again later.',
                        spam_risk_too_many_posts: "You've reached the daily post limit on TikTok. Please try again later.",
                        spam_risk_user_banned_from_posting: 'This TikTok account is currently banned from posting.',
                        unaudited_client_can_only_post_to_private_accounts: 'This app can currently only post privately on TikTok. Set the video to Private and try again.',
                        url_ownership_unverified: 'TikTok could not verify the video source. Please contact support.',
                    };
                    const friendly = messages[code] || error?.response?.data?.error?.message || error.message;
                    setUploadMessage('Upload failed: ' + friendly);
                    toast.error(friendly);
                });
        } catch (error) {
            console.error('Error while checking video duration:', error);
            toast.error('Error uploading video: ' + error.message);
        }
    };

    // const handleTiktokFeedsSubmit = (event) => {
    //     event.preventDefault();

    //     if (!validateTiktokForm()) {
    //         return; // Stop the form submission if validation fails
    //     }

    //     setIsUploading(true); // Start upload
    //     setUploadMessage('');
    //     setAlertShow(false);

    //     const data = {
    //         video_url: video_url,
    //         tiktokvideoTitle: tiktokvideoTitle,
    //         tiktokaccessSpecifier: tiktokaccessSpecifier,
    //         comment: comment,
    //         duet: duet,
    //         stitch: stitch,

    //     };
    //     // Request video upload
    //     axios.post(apiUrl + '/upload/tiktok_feeds', data, {
    //         headers: {
    //             Authorization: `Bearer ${localStorage.getItem('tiktokToken')}`
    //         }
    //     })
    //         .then(response => {
    //             setIsUploading(false); // Upload complete
    //             toast.success('Video uploaded successfully!');
    //             setUploadMessage('Once the video is generated, we will upload it to Tiktok with the metadata you submitted');
    //             setAlertShow(true); // Show
    //         })
    //         .catch(error => {
    //             setIsUploading(false); // Upload complete
    //             setUploadMessage('Upload failed: ' + error.message);
    //         });
    // };

    const MAX_TITLE_LENGTH = 100;
    const MAX_DESCRIPTION_LENGTH = 5000;

    const handleTitleChange = (event) => {
        if (event.target.value.length <= MAX_TITLE_LENGTH) {
            setVideoTitle(event.target.value);
        }
    };

    const handleDescriptionChange = (event) => {
        if (event.target.value.length <= MAX_DESCRIPTION_LENGTH) {
            setVideoDescription(event.target.value);
        }
    };

    const handleAccessSpecifierChange = (event) => {
        setAccessSpecifier(event.target.value);
    };

    // tiktok handlers
    const handletiktokTitleChange = (event) => {
        if (event.target.value.length <= MAX_TITLE_LENGTH) {
            settiktokVideoTitle(event.target.value);
        }
    };
    // const handletiktokAccessSpecifierChange = (event) => {
    //     settiktokAccessSpecifier(event.target.value);
    //     if (event.target.value == 'SELF_ONLY') {
    //         setTiktokBrandedContent(false);
    //     }
    // };

    const handletiktokAccessSpecifierChange = (event) => {
        const selectedValue = event.target.value;
        settiktokAccessSpecifier(selectedValue);
        // Private posts can't carry branded content — uncheck it if the user
        // switches visibility to "Only me".
        if (selectedValue === PRIVACY_OPTIONS.SELF_ONLY && tiktokBrandedContent) {
            setTiktokBrandedContent(false);
        }
    };

    const handleBrandedContentChange = () => {
        const next = !tiktokBrandedContent;
        setTiktokBrandedContent(next);
        // Branded content can't be private. If the current visibility is private,
        // move it to public and let the user know (TikTok UX requirement).
        if (next && tiktokaccessSpecifier === PRIVACY_OPTIONS.SELF_ONLY) {
            settiktokAccessSpecifier(PRIVACY_OPTIONS.PUBLIC_TO_EVERYONE);
            toast.info("Branded content can't be set to private — visibility switched to Public.");
        }
    };

    const handleDiscloseToggle = () => {
        const next = !tiktokDisclose;
        setTiktokDisclose(next);
        // Turning disclosure OFF clears any commercial-content selections, so the
        // labels, legal declaration, and the brand_organic/brand_content flags sent
        // to TikTok all reset to "not commercial".
        if (!next) {
            setTiktokYourBrand(false);
            setTiktokBrandedContent(false);
        }
    };

    useEffect(() => {
        const receiveMessage = (event) => {
            if (event.data.type === 'error') {
                toast.error(event.data.message);
            }
            // Validate the origin if needed
            if (event.data.type === 'googleSuccess') {
                localStorage.setItem('googleToken', event.data.googleToken);
                localStorage.setItem('platform', 'google');
                setIsLoggedIn(true);
            }
            if (event.data.type === 'instaSuccess') {
                localStorage.setItem('instagramToken', event.data.insta_token);
                localStorage.setItem('instagramAuthToken', event.data.insta_auth_token);
                localStorage.setItem('platform', 'instagram');
                setIsInstaLoggedIn(true);
            }
            if (event.data.type === 'tiktokSuccess') {
                localStorage.setItem('tiktokToken', event.data.tiktok_token);
                localStorage.setItem('tiktokAuthToken', event.data.tiktok_auth_token);
                localStorage.setItem('platform', 'tiktok');
                setIsTiktokLoggedIn(true);
            }
        };
        window.addEventListener('message', receiveMessage);
        return () => {
            window.removeEventListener('message', receiveMessage);
        };
    }, []);


    return (
        <>
            <ToastContainer position="top-center" autoClose={5000} hideProgressBar={false} />

            {/* TikTok publish status overlay: processing -> success / error */}
            {publishId && !statusOverlayDismissed && (
                <div style={{
                    position: 'fixed', inset: 0, zIndex: 99999,
                    background: 'rgba(15,23,42,0.55)', backdropFilter: 'blur(2px)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16,
                }}>
                    <div style={{
                        background: '#fff', borderRadius: 16, padding: '32px 28px',
                        width: 'min(92vw, 380px)', textAlign: 'center',
                        boxShadow: '0 20px 60px rgba(0,0,0,0.35)',
                    }}>
                        {uploadStatus === 'PUBLISH_COMPLETE' ? (
                            <>
                                <div style={{
                                    width: 64, height: 64, borderRadius: '50%', margin: '0 auto 18px',
                                    background: '#22c55e', display: 'flex', alignItems: 'center',
                                    justifyContent: 'center', fontSize: 34, color: '#fff', fontWeight: 700,
                                }}>✓</div>
                                <h3 style={{ margin: '0 0 8px', fontSize: 20, fontWeight: 700, color: '#0f172a' }}>
                                    Posted to TikTok!
                                </h3>
                                <p style={{ margin: '0 0 20px', fontSize: 14, color: '#64748b' }}>
                                    Your video has been published successfully.
                                </p>
                                {tiktokPostUrl && (
                                    <a href={tiktokPostUrl} target="_blank" rel="noopener noreferrer"
                                        style={{
                                            display: 'inline-block', width: '100%', boxSizing: 'border-box',
                                            background: '#000', color: '#fff', textDecoration: 'none',
                                            padding: '11px 16px', borderRadius: 10, fontWeight: 600,
                                            fontSize: 14, marginBottom: 10,
                                        }}>
                                        View on TikTok ↗
                                    </a>
                                )}
                                <button onClick={() => setStatusOverlayDismissed(true)}
                                    style={{
                                        width: '100%', background: 'transparent', color: '#64748b',
                                        border: '1px solid #e2e8f0', padding: '10px 16px', borderRadius: 10,
                                        fontWeight: 600, fontSize: 14, cursor: 'pointer',
                                    }}>
                                    Done
                                </button>
                            </>
                        ) : (uploadStatus === 'FAILED' || uploadStatus === 'PUBLISH_FAILED') ? (
                            <>
                                <div style={{
                                    width: 64, height: 64, borderRadius: '50%', margin: '0 auto 18px',
                                    background: '#ef4444', display: 'flex', alignItems: 'center',
                                    justifyContent: 'center', fontSize: 34, color: '#fff', fontWeight: 700,
                                }}>!</div>
                                <h3 style={{ margin: '0 0 8px', fontSize: 20, fontWeight: 700, color: '#0f172a' }}>
                                    Upload failed
                                </h3>
                                <p style={{ margin: '0 0 20px', fontSize: 14, color: '#64748b' }}>
                                    {uploadError || 'Something went wrong while posting to TikTok.'}
                                </p>
                                <button onClick={() => setStatusOverlayDismissed(true)}
                                    style={{
                                        width: '100%', background: '#0f172a', color: '#fff', border: 'none',
                                        padding: '11px 16px', borderRadius: 10, fontWeight: 600, fontSize: 14, cursor: 'pointer',
                                    }}>
                                    Close
                                </button>
                            </>
                        ) : (
                            <>
                                <div className="spinner-border" role="status" style={{
                                    width: 56, height: 56, color: '#000', borderWidth: 5, marginBottom: 18,
                                }}><span className="visually-hidden">Loading...</span></div>
                                <h3 style={{ margin: '0 0 8px', fontSize: 18, fontWeight: 700, color: '#0f172a' }}>
                                    Posting to TikTok…
                                </h3>
                                <p style={{ margin: 0, fontSize: 14, color: '#64748b' }}>
                                    {uploadStatus === 'PROCESSING_UPLOAD' ? 'Processing your video…'
                                        : uploadStatus === 'SEND_TO_USER_INBOX' ? 'Finalizing…'
                                            : 'TikTok is fetching your video…'}
                                </p>
                            </>
                        )}
                    </div>
                </div>
            )}

            <LoadingOverlay
                active={isUploading}
                spinner
                text='Uploading video...'
                styles={{ display: 'contents' }}
            />

            <Header />

            <div className="sc_small_center flex-column pt-3 pb-5">

                <button
                    type="button"
                    onClick={handleBack}
                    className='btn btn-link'
                    style={{ alignSelf: 'flex-start', textDecoration: 'none', color: '#526078', fontWeight: 600, paddingLeft: 0 }}
                >
                    ‹ Back
                </button>

                <h1 className='mt-2'>Upload Clip To Social Media</h1>
                <p>Use the social media options listed below to upload the generated clip:</p>
                <div className=''>
                    <Accordion defaultActiveKey="1">
                        <Accordion.Item eventKey="0">
                            <Accordion.Header>
                                <img className='socialIconsSmalll' src={youtube_icon} />
                                Upload to YouTube Shorts
                                {
                                    isLoggedIn && (
                                        <a onClick={() => handleDisconnect('google')} className='disconnectbtn btn btn-lg btn-link'>Disconnect</a>
                                    )
                                }</Accordion.Header>
                            <Accordion.Body>
                                <div className="socialWrapper">
                                    {!isLoading && !isLoggedIn && (
                                        <button
                                            className="ytConnect btn btn-group-vertical btn-outline-secondary"
                                            onClick={
                                                () => handleLogin('google')
                                            }
                                        >
                                            <img src={connect_with_yt} alt='Connect with You Tube' />Connect with You Tube
                                        </button>
                                    )}

                                    {
                                        isLoggedIn && (
                                            <>
                                                {/* {channelInfo?.google && (
                                                    <div className='channelInfo card p-4 mb-4'>
                                                        <div className='d-flex align-items-center'>
                                                            {channelInfo.google.thumbnails?.default?.url && (
                                                                <img 
                                                                    src={channelInfo.google.thumbnails.default.url} 
                                                                    alt="Channel thumbnail"
                                                                    className="rounded-circle me-3"
                                                                    style={{ width: '50px', height: '50px' }}
                                                                />
                                                            )}
                                                            <div>
                                                                <h3 className="mb-1">{channelInfo.google.title} | {channelInfo?.google?.customUrl}</h3>
                                                                <p className="text-muted mb-0">Channel ID: {channelInfo.google.id}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )} */}

                                                <div className='row'>
                                                    <div className='col-md-4'>
                                                        {userInfo?.google && userInfo?.google?.email && (
                                                            <div className='card p-3 text-center mb-3'>
                                                                <img 
                                                                    src={userInfo?.google?.picture} 
                                                                    alt={userInfo?.google?.name}
                                                                    className="rounded-circle mx-auto mb-2"
                                                                    style={{ width: '80px', height: '80px' }}
                                                                />
                                                                <h4 className="mb-0">{userInfo?.google?.name}</h4>
                                                                <p className="text-muted small">{userInfo?.google?.email}</p>
                                                            </div>
                                                        )}
                                                        
                                                        <div className="card video-preview-card">
                                                            <div className="card-body p-2">
                                                                <VideoPlayer src={video_url} />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='col-md-8'>
                                                        <div className='card'>
                                                            <div className='card-body'>
                                                                <h4 className="card-title mb-4">Upload Details</h4>
                                                                <form>
                                                                    <div className='formWrapper'>
                                                                        <div className='form-group mb-4'>
                                                                            <label className="form-label d-flex justify-content-between">
                                                                                Title 
                                                                                <span className="text-muted">
                                                                                    {videoTitle.length}/{MAX_TITLE_LENGTH}
                                                                                </span>
                                                                            </label>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                id="videoTitle"
                                                                                placeholder="Enter a catchy title for your video"
                                                                                value={videoTitle}
                                                                                onChange={handleTitleChange}
                                                                            />
                                                                        </div>

                                                                        <div className='form-group mb-4'>
                                                                            <label className="form-label d-flex justify-content-between">
                                                                                Description
                                                                                <span className="text-muted">
                                                                                    {videoDescription.length}/{MAX_DESCRIPTION_LENGTH}
                                                                                </span>
                                                                            </label>
                                                                            <textarea
                                                                                className="form-control"
                                                                                id="videoDescription"
                                                                                rows="4"
                                                                                placeholder="Describe your video to help viewers find it"
                                                                                value={videoDescription}
                                                                                onChange={handleDescriptionChange}
                                                                            />
                                                                        </div>

                                                                        <div className="form-group mb-4">
                                                                            <label className="form-label">Privacy Settings</label>
                                                                            <select
                                                                                className="form-select"
                                                                                value={accessSpecifier}
                                                                                onChange={handleAccessSpecifierChange}
                                                                            >
                                                                                <option value="public">Public</option>
                                                                                <option value="private">Private</option>
                                                                                <option value="unlisted">Unlisted</option>
                                                                            </select>
                                                                        </div>
                                                                    </div>

                                                                    <div className='form-check mb-4'>
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="checkbox"
                                                                            id="termsAgreement"
                                                                            onChange={(e) => setTermsAgreed(e.target.checked)}
                                                                        />
                                                                        <label className="form-check-label small" htmlFor="termsAgreement">
                                                                            By using this application to upload content to YouTube, you agree to abide by
                                                                            <a href="https://www.youtube.com/static?template=terms" target="_blank" rel="noopener noreferrer">
                                                                                &nbsp;YouTube's Terms of Service&nbsp;
                                                                            </a>
                                                                            and
                                                                            <a href="https://www.youtube.com/intl/ALL_in/howyoutubeworks/policies/copyright/" target="_blank" rel="noopener noreferrer">
                                                                                &nbsp;Copyright Policies&nbsp;
                                                                            </a>.
                                                                        </label>
                                                                    </div>

                                                                    <Button 
                                                                        variant="primary" 
                                                                        type='submit' 
                                                                        onClick={handleSubmit}
                                                                        className="w-100"
                                                                        disabled={!IsTermsAgreed}
                                                                    >
                                                                        Publish to YouTube
                                                                    </Button>
                                                                </form>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        )
                                    }


                                </div>
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="1">
                            <Accordion.Header>
                                <img className='socialIconsSmalll' src={instagram_icon} />
                                Upload to Instagram Reel {
                                    isInstaLoggedIn && (
                                        <a onClick={
                                            () => handleDisconnect('instagram')
                                        }
                                            className='disconnectbtn btn btn-lg btn-link'>
                                            Disconnect
                                        </a>)
                                }
                            </Accordion.Header>
                            <Accordion.Body>
                                {/* {!isLoading && !isInstaLoggedIn && (
                                    <button
                                        className="InstaConnect btn btn-primary d-flex gap-3"
                                        onClick={handlesetShow}
                                    >
                                        <img src={connect_with_insta} alt='Connect with Instagram' />Login with Facebook
                                    </button>
                                )} */}

                                {!isLoading && !isInstaLoggedIn && (
                                    <div className="insta-default">
                                        <button onClick={handlesetShow} className="insta-default">Log in with Instagram <i className="fab fa-instagram"></i></button>
                                    </div>
                                )}


                                {
                                    isInstaLoggedIn && (
                                        <div className='row'>
                                            <div className="col-4">
                                                <div className='userinfoWrapperWrap'>

                                                    <div className="shadow videoPreview">
                                                        <video
                                                            id="editVideo"
                                                            controls="controls"
                                                        >
                                                            <source
                                                                src={video_url}
                                                                type="video/mp4"
                                                            />
                                                        </video>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-8">
                                                <form className=''>
                                                    <h4
                                                        style={{
                                                            fontSize: 21,
                                                            fontWeight: "bold",
                                                            borderBottom: "1px solid #ccc",
                                                            paddingBottom: 20
                                                        }}
                                                    >
                                                        Upload Short to Instagram Reel
                                                    </h4>
                                                    <p>
                                                        Enter a captivating caption for your video short, then select the appropriate Facebook page and its associated Instagram account where you'd like to share this engaging content with your audience.
                                                    </p>

                                                    <Form.Group className="mb-3" controlId="ssForm.ControlInput1">
                                                        <Form.Label>Caption</Form.Label>
                                                        <Form.Control type="text" placeholder="Write a Caption and add Hashtags"
                                                            value={videoTitle} onChange={handleTitleChange}
                                                        />
                                                    </Form.Group>
                                                   

                                                    {userInfo.instagram.user && (
                                                        <Form.Group className="mb-3" controlId="ssForm.ControlTextarea1">
                                                            <Form.Label>Instagram Account</Form.Label>
                                                            <div className="row">
                                                                <div className="col-12">
                                                                    <Card
                                                                        className={`m-2 ${instagramBusinessAccountId === userInfo.instagram.user.id ? 'border-primary' : ''}`}
                                                                        style={{ cursor: 'pointer' }}
                                                                        onClick={() => setInstagramBusinessAccountId(userInfo.instagram.user.id)}
                                                                    >
                                                                        <Card.Body>
                                                                            <Form.Check
                                                                                type="radio"
                                                                                id={`instagram-account-${userInfo.instagram.user.id}`}
                                                                                label={`@${userInfo.instagram.user.username} (${userInfo.instagram.user.account_type})`}
                                                                                name="instagram_account_id"
                                                                                value={userInfo.instagram.user.id}
                                                                                checked={instagramBusinessAccountId === userInfo.instagram.user.id}
                                                                                onChange={handleInstagramAccountChange}
                                                                            />
                                                                        </Card.Body>
                                                                    </Card>
                                                                </div>
                                                            </div>
                                                        </Form.Group>
                                                    )}

                                                    
                                                        <Button disabled={instagramBusinessAccountId != '' ? '': 'true'} variant="success btn-full" type='submit' onClick={handleInstaSubmit}>
                                                            Upload to Instagram Reel
                                                        </Button>
                                                    
                                                </form>
                                            </div>


                                        </div>
                                    )
                                }
                            </Accordion.Body>
                        </Accordion.Item>
                        <Accordion.Item eventKey="2">
                            <Accordion.Header>
                                <img className='socialIconsSmalll' src={tiktok_icon} />
                                Upload to TikTok{' '}

                                {isTiktokLoggedIn && (
                                    <a onClick={() => handleDisconnect('tiktok')} className="disconnectbtn btn btn-lg btn-link">
                                        Disconnect
                                    </a>
                                )}
                            </Accordion.Header>
                            <Accordion.Body>
                                {!isLoading && !isTiktokLoggedIn && (
                                    <button
                                        className="tiktokConnect btn btn-group-vertical btn-outline-primary"
                                        onClick={() => handleLogin('tiktok')}
                                    >
                                        <img src={connect_with_tiktok} alt="Connect with tiktok" />
                                        Connect with tiktok
                                    </button>
                                )}

                                {isTiktokLoggedIn && (
                                    <>
                                        {!canPost && (
                                            <div className="alert alert-danger mb-4 w-100">
                                                <strong>Can't post right now:</strong> {whyCant || 'This TikTok account cannot accept new posts at the moment. Please try again later.'}
                                            </div>
                                        )}
                                        <div className='tiktokFormAndVideoWraper ttReskin'>
                                            <div className="userinfoWrapperWrap">
                                                {userInfo?.tiktok?.data && userInfo?.tiktok?.data?.creator_nickname && (
                                                    <div className="ttAccountChip">
                                                        <img className="ttAccountAvatar" src={userInfo?.tiktok?.data?.creator_avatar_url} alt="" />
                                                        <span className="ttAccountName">{userInfo?.tiktok?.data?.creator_nickname}</span>
                                                    </div>
                                                )}
                                                <div className="ttVideoCard">
                                                    <div className="ttVideoFrame videoPreview">
                                                        <VideoPlayer src={video_url} hasControls={true} />
                                                    </div>
                                                    <div className="ttVideoMeta">
                                                        <div className="ttMetaItem">
                                                            <span className="ttMetaLabel">Filename</span>
                                                            <span className="ttMetaValue" title={videoMeta.filename}>{videoMeta.filename || '—'}</span>
                                                        </div>
                                                        <div className="ttMetaItem">
                                                            <span className="ttMetaLabel">Format</span>
                                                            <span className="ttMetaValue">{videoMeta.format || '—'}</span>
                                                        </div>
                                                        <div className="ttMetaItem">
                                                            <span className="ttMetaLabel">Resolution</span>
                                                            <span className="ttMetaValue">{videoMeta.resolution || '—'}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <form className="ss_tiktokForm">
                                                <div className="formWrapper">
                                                   
                                                    <div className="validation-sorts" style={{ display: 'none' }}>
                                                        Cannot be shared. Videos shared on tiktok Reels must be between 3 seconds and 15 minutes in
                                                        length and must not exceed 1GB.
                                                    </div>
                                                    <div className="inputWrapper">
                                                        <label className="label">Caption</label>
                                                        <div className="ttInputWrap">
                                                            <input
                                                                type="text"
                                                                className="textbox text-control ttInput"
                                                                placeholder="Add a title that describes your video"
                                                                name="tiktokTitle"
                                                                maxLength={MAX_TITLE_LENGTH}
                                                                value={tiktokvideoTitle}
                                                                onChange={handletiktokTitleChange}
                                                            />
                                                            <span className="ttCharCount">{tiktokvideoTitle.length}/{MAX_TITLE_LENGTH}</span>
                                                        </div>
                                                    </div>
                                                    <div className="inputWrapper select-wrapper">
                                                        <label className="label">
                                                            Who can view this video
                                                        </label>
                                                        <select
                                                            className="accessSpecifiers"
                                                            value={tiktokaccessSpecifier}
                                                            onChange={handletiktokAccessSpecifierChange}
                                                        >
                                                            <option value="" disabled>
                                                                Choose Privacy Status
                                                            </option>
                                                            {(userInfo?.tiktok?.data?.privacy_level_options || []).map((option) => {
                                                                const privateDisabled =
                                                                    option === PRIVACY_OPTIONS.SELF_ONLY && tiktokBrandedContent;
                                                                return (
                                                                    <option
                                                                        key={option}
                                                                        value={option}
                                                                        disabled={privateDisabled}
                                                                        title={privateDisabled ? "Branded content visibility can't be private" : undefined}
                                                                    >
                                                                        {PRIVACY_LABELS[option] || option}
                                                                    </option>
                                                                );
                                                            })}
                                                        </select>
                                                        {tiktokBrandedContent && (
                                                            <p className="mt-2 mb-0" style={{ fontSize: '0.85rem', color: '#856404' }}>
                                                                Branded content visibility can't be set to private.
                                                            </p>
                                                        )}
                                                    </div>
                                                    <div className="inputWrapper">
                                                        <label className="label">
                                                            Allow users to
                                                        </label>
                                                        <div className="checkboxInlineWrapper mt-3">
                                                            <div className="form-check form-check-inline checkboxWrapper">
                                                                <input
                                                                    disabled={userInfo?.tiktok?.data?.comment_disabled}
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    id="Comment"
                                                                    checked={comment}
                                                                    onChange={(e) => setComment(e.target.checked)}
                                                                />
                                                                <label className="form-check-label" htmlFor="Comment">
                                                                    Comment
                                                                </label>
                                                            </div>
                                                            <div className="form-check form-check-inline checkboxWrapper">
                                                                <input
                                                                    disabled={userInfo?.tiktok?.data?.duet_disabled}
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    id="Duet"
                                                                    checked={duet}
                                                                    onChange={(e) => setDuet(e.target.checked)}
                                                                />
                                                                <label className="form-check-label" htmlFor="Duet">
                                                                    Duet
                                                                </label>
                                                            </div>

                                                            <div className="form-check form-check-inline checkboxWrapper">
                                                                <input
                                                                    disabled={userInfo?.tiktok?.data?.stitch_disabled}
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    id="Stitch"
                                                                    checked={stitch}
                                                                    onChange={(e) => setStitch(e.target.checked)}
                                                                />
                                                                <label className="form-check-label" htmlFor="Stitch">
                                                                    Stitch
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="discloseVideoContentWrap ttDisclose mt-4">
                                                        <div className="toggleWraper">
                                                            <div className="form-check form-switch d-flex justify-content-between align-items-center">
                                                                <div className="d-flex align-items-center" style={{width: '96%'}}>
                                                                    <label className="form-check-label me-3" htmlFor="flexSwitchCheckDefault">
                                                                        <strong>Disclose video content</strong>
                                                                        <OverlayTrigger
                                                                            key="top"
                                                                            placement="top"
                                                                            overlay={
                                                                                <Tooltip id="tooltip-top">
                                                                                    Turn this on only if your video promotes a brand, product, or service — your own or someone else's. Leave it off for regular videos.
                                                                                </Tooltip>
                                                                            }
                                                                        >
                                                                            <img
                                                                                src={info_icon}
                                                                                alt="Info icon"
                                                                                data-bs-toggle="tooltip"
                                                                                data-bs-placement="top"
                                                                                title="Tooltip on top"
                                                                                style={{marginLeft: '8px'}}
                                                                            />
                                                                        </OverlayTrigger>
                                                                    </label>
                                                                </div>
                                                                <input
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    role="switch"
                                                                    id="flexSwitchCheckDefault"
                                                                    checked={tiktokDisclose}
                                                                    onChange={handleDiscloseToggle}
                                                                />
                                                            </div>
                                                        </div>
                                                        <p className="ttDiscloseDesc">
                                                            Turn on to disclose that this video promotes goods or services in exchange for something of value. Your video could promote yourself, a third party, or both.
                                                        </p>
                                                        <div className="mt-3">
                                                            {tiktokBrandedContent && !tiktokYourBrand ? (
                                                                <div className="msg-tool alert alert-info mt-3">
                                                                    <img
                                                                        src={info_icon}
                                                                        alt="Info icon"
                                                                        data-bs-toggle="tooltip"
                                                                        data-bs-placement="top"
                                                                        title="Tooltip on top"
                                                                    />
                                                                    <p>Your video will be labeled "Paid partnership". This cannot be changed once your video is posted.</p>
                                                                </div>
                                                            ) : null}
                                                            {tiktokYourBrand && !tiktokBrandedContent ? (
                                                                <div className="msg-tool alert alert-info mt-3">
                                                                    <img
                                                                        src={info_icon}
                                                                        alt="Info icon"
                                                                        data-bs-toggle="tooltip"
                                                                        data-bs-placement="top"
                                                                        title="Tooltip on top"
                                                                    />
                                                                    <p>Your video will be labeled "Promotional content". This cannot be changed once your video is posted.</p>
                                                                </div>
                                                            ) : null}
                                                            {tiktokBrandedContent && tiktokYourBrand ? (
                                                                <div className="msg-tool alert alert-info mt-3">
                                                                    <img
                                                                        src={info_icon}
                                                                        alt="Info icon"
                                                                        data-bs-toggle="tooltip"
                                                                        data-bs-placement="top"
                                                                        title="Tooltip on top"
                                                                    />
                                                                    <p>Your video will be labeled "Paid partnership". This cannot be changed once your video is posted.</p>
                                                                </div>
                                                            ) : null}
                                                        </div>
                                                        {tiktokDisclose && (
                                                            <div className="disclauseCheckboxes">
                                                                <div className="form-check">
                                                                    <input
                                                                        className="form-check-input float-end"
                                                                        type="checkbox"
                                                                        id="flexCheckYourBrand"
                                                                        checked={tiktokYourBrand}
                                                                        onChange={() => setTiktokYourBrand(!tiktokYourBrand)}
                                                                    />
                                                                    <label className="form-check-label" htmlFor="flexCheckYourBrand">
                                                                        Your Brand
                                                                    </label>
                                                                    <p>You are promoting yourself or your own business. This content will be classified as Brand Organic.</p>
                                                                </div>

                                                                <div className="form-check">
                                                                    <input
                                                                        disabled={!(userInfo?.tiktok?.data?.privacy_level_options || []).some((o) => o !== PRIVACY_OPTIONS.SELF_ONLY)}
                                                                        className="form-check-input float-end"
                                                                        type="checkbox"
                                                                        id="flexCheckBrandedContent"
                                                                        checked={tiktokBrandedContent}
                                                                        onChange={handleBrandedContentChange}
                                                                    />
                                                                    <label className="form-check-label" htmlFor="flexCheckBrandedContent">
                                                                        Branded Content
                                                                    </label>
                                                                    <p>You are promoting another brand or a third party. This content will be classified as Branded Content.</p>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <hr />
                                                <div className="declarationWrapper">
                                                    {tiktokYourBrand && !tiktokBrandedContent ? (
                                                        <p>
                                                            By posting, you agree to TikTok's{' '}
                                                            <a href="https://www.tiktok.com/legal/page/global/music-usage-confirmation/en" target="_blank" rel="noopener noreferrer">
                                                                Music Usage Confirmation
                                                            </a>
                                                            .
                                                        </p>
                                                    ) : tiktokBrandedContent && !tiktokYourBrand ? (
                                                        <p>
                                                            By posting, you agree to TikTok's{' '}
                                                            <a href="https://www.tiktok.com/legal/page/global/bc-policy/en" target="_blank" rel="noopener noreferrer">
                                                                Branded Content Policy
                                                            </a>{' '}
                                                            and{' '}
                                                            <a href="https://www.tiktok.com/legal/page/global/music-usage-confirmation/en" target="_blank" rel="noopener noreferrer">
                                                                Music Usage Confirmation
                                                            </a>
                                                            .
                                                        </p>
                                                    ) : tiktokBrandedContent && tiktokYourBrand ? (
                                                        <p>
                                                            By posting, you agree to TikTok's{' '}
                                                            <a href="https://www.tiktok.com/legal/page/global/bc-policy/en" target="_blank" rel="noopener noreferrer">
                                                                Branded Content Policy
                                                            </a>{' '}
                                                            and{' '}
                                                            <a href="https://www.tiktok.com/legal/page/global/music-usage-confirmation/en" target="_blank" rel="noopener noreferrer">
                                                                Music Usage Confirmation
                                                            </a>
                                                            .
                                                        </p>
                                                    ) : (
                                                        <p>
                                                            By posting, you agree to TikTok's{' '}
                                                            <a href="https://www.tiktok.com/legal/page/global/music-usage-confirmation/en" target="_blank" rel="noopener noreferrer">
                                                                Music Usage Confirmation
                                                            </a>
                                                            .
                                                        </p>
                                                    )}
                                                </div>

                                                {(() => {
                                                    const blockReason = isUploading ? '' : getPublishBlockReason();
                                                    const uploadBtn = (
                                                        <Button
                                                            className='btn btn-full btn-info mb-3 mt-3'
                                                            type="submit"
                                                            onClick={handleTiktokFeedsSubmit}
                                                            disabled={!!blockReason || isUploading}
                                                            style={blockReason ? { pointerEvents: 'none' } : undefined}
                                                        >
                                                            Upload
                                                        </Button>
                                                    );
                                                    return blockReason ? (
                                                        <OverlayTrigger
                                                            placement="top"
                                                            overlay={<Tooltip id="tooltip-publish">{blockReason}</Tooltip>}
                                                        >
                                                            <span className="d-inline-block" style={{ width: '100%' }}>{uploadBtn}</span>
                                                        </OverlayTrigger>
                                                    ) : uploadBtn;
                                                })()}

                                                <p className='mt-3'><b>Please note: </b>After publishing your content, it may take a few minutes to process and appear on your profile. Thank you for your patience.</p>

                                            </form>

                                        </div>

                                        {recentVideos.length > 0 && (
                                            <div className="ttRecentPosts ttReskin">
                                                <button
                                                    type="button"
                                                    className={`ttRecentHeader${showRecentVideos ? ' open' : ''}`}
                                                    onClick={() => setShowRecentVideos(!showRecentVideos)}
                                                    aria-expanded={showRecentVideos}
                                                >
                                                    <h4 className="ttRecentTitle">Your recent TikTok posts</h4>
                                                    <span className="ttRecentChevron" aria-hidden="true">⌄</span>
                                                </button>
                                                {showRecentVideos && (
                                                    <div className="ttRecentRow">
                                                        {recentVideos.map((v) => (
                                                            <a
                                                                key={v.id}
                                                                className="ttRecentCard"
                                                                href={v.share_url}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                <div className="ttRecentThumb">
                                                                    {v.cover_image_url ? (
                                                                        <img src={v.cover_image_url} alt={v.title || 'TikTok video'} />
                                                                    ) : null}
                                                                </div>
                                                                <span className="ttRecentCaption">{v.title || 'Untitled'}</span>
                                                            </a>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </>
                                )}
                            </Accordion.Body>
                        </Accordion.Item>
                        {X_ENABLED && (
                            <XUploadPanel eventKey="3" apiUrl={apiUrl} callbackUrl={App_Url} videoUrl={video_url} />
                        )}
                    </Accordion>

                    <Link to="/">
                        <button className='btn btn-lg btn-link mt-2'>Go back to Home</button>
                    </Link>

                </div>
            </div>






            <Modal className="ss_modal instagram_model ss_dark" show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <div className="instagram_Tutrial_header">
                        <h3>Instagram connection</h3>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <InstagramTutorial />
                </Modal.Body>
                <Modal.Footer>
                    <button type='button' className="instagram_button" onClick={() => handleLogin('instagram')}>Continue</button>
                </Modal.Footer>
            </Modal>


            <Modal className="ss_modal instagram_thankyou_model ss_dark" show={thankyoushow} onHide={handleThankYouClose}>
                <Modal.Header closeButton>
                    <div className="instagram_Tutrial_header">
                        {/* <h3>Instagram</h3> */}
                    </div>
                </Modal.Header>
                <Modal.Body className="text-center">
                    <h3>Thank you</h3>
                    <h4>Your Video has been uploaded to Instagram</h4>
                    <p><a className="btn btn-outline-success" target="_blank" href={uploadedMediaUrl}>View video on Instagram <img src={instagram_icon} /></a></p>
                </Modal.Body>
                <Modal.Footer>
                    <button type='button' className="instagram_button btn btn-danger" onClick={() => handleThankYouClose()}>Close</button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default AuthSection;
